export const chatContainer = document.getElementById("chat");
export const sendButton = document.getElementById("send-button");
export const userInput = document.getElementById("user-input");
export const controlsElement = document.getElementById("controls");
export const footerElement = document.getElementById("footer");
